import { IS_CLIENT } from '../../constants';
import { getWrappedSrc } from './getWrappedSrc';
// Desktop: w 302px, h 453px
// Mobile: w 192px, h 288px
const liquidPixelResolutionMapping = {
    192: '288',
    302: '453',
};
export const sizes = Object.keys(liquidPixelResolutionMapping);
export const wrapCommunityContentImageSrc = (src, closestWidth, useDevPrefixedUrl) => {
    const httpSrc = src.includes('http') || !IS_CLIENT ? src : `${window.location.origin}${src}`;
    return getWrappedSrc(httpSrc, liquidPixelResolutionMapping[closestWidth], useDevPrefixedUrl);
};
//# sourceMappingURL=communityContentImageMappings.js.map